import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import { useIntl } from 'react-intl';

import css from './BooksDateCalendarMonth.module.scss';

interface DayProps extends ComponentProps<'button'> {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  date: number;
  disabled: boolean;
  current: boolean;
  selected?: boolean;
}

interface MonthProps {
  children?: React.ReactNode;
}

export const BooksDateCalendarDay = ({
  onClick,
  date,
  disabled,
  selected,
  current,
  ...attr
}: DayProps) => {
  return (
    <li className={css.BooksDateCalendarDay}>
      {current && (
        <button
          {...attr}
          type="button"
          onClick={onClick}
          disabled={disabled}
          className={css.BooksDateCalendarDay__Button}
          data-style={selected ? 'selected' : ''}
          data-e2e={`${disabled ? 'disabled' : 'available'}CalendarButton`}
        >
          {date}
        </button>
      )}
    </li>
  );
};

const BooksDateCalendarMonth = ({ children }: MonthProps) => {
  const intl = useIntl();
  const classes = classNames(css.BooksDateCalendarMonth);
  const dateCalendarWeek = ['sun', 'man', 'tue', 'wed', 'thu', 'fri', 'sat'];

  return (
    <div className={classes}>
      <ol className={css.BooksDateCalendarMonth__Dotw}>
        {dateCalendarWeek.map((weekday, i) => (
          <li key={i} className={css.BooksDateCalendarMonth__DotwItem}>
            {intl.formatMessage({ id: `books.calendar.${weekday}` })}
          </li>
        ))}
      </ol>
      <div className={css.BooksDateCalendarMonth__Body}>
        <ol className={css.BooksDateCalendarMonth__Day}>{children}</ol>
      </div>
    </div>
  );
};

export default BooksDateCalendarMonth;
